import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaderResponse, HttpHeaders, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { FavoritesListService } from '../favorites-list/favorites-list.component.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {

  public results = [];
  public apiKey = "e7c9c5a095mshe6148648b6bf74ep1e37e8jsn541fb2b0df2c";
  public apiHeader = new HttpHeaders().set("X-Rapidapi-Key", this.apiKey).set("X-Rapidapi-Host", "v1-sneakers-test.p.rapidapi.com");
  
  constructor(private http: HttpClient, private favoritesListService: FavoritesListService, private SpinnerService: NgxSpinnerService) { }

  getResults()
  {
    console.log(this.results)
    return this.results;
  }

  clearResults()
  {
    this.results = [];
  }

  addToResults(shoe)
  {
    this.results.push(shoe);
  }

  removeFromResults(shoe)
  {
    this.results.splice(this.results.indexOf(shoe), 1);
  }

  async setResultsByUrl(url)
  {
    this.SpinnerService.show();

    return new Promise<void>(resolve => 
      {
        console.log(this.apiHeader);
        this.http.get<any>(url, {headers: this.apiHeader}).subscribe(data => 
        {      
          this.results = data;
          this.convertResultsToSearchShoes(data.results);
          this.SpinnerService.hide();
          resolve();
        });
    });    
  }

  convertResultsToSearchShoes(results)
  {
    this.clearResults();

    for(let i = 0; i < 100; i++)
    {
      let tempShoe;

      if(results[i] == undefined)
      { 
        break;
      }

      if(!this.shoeHasImage(results[i]))
      {
        results.splice(i, 1);
        continue;
      }

      tempShoe = 
      {
        id: results[i].id,
        brand: results[i].brand,
        gender: results[i].gender,
        img: results[i].media.imageUrl,
        retailPrice: results[i].retailPrice,
        shoe: results[i].shoe,
        name: results[i].name
      }

      if(this.isShoeInFavorites(tempShoe))
      {
        continue;
      }

      this.addToResults(tempShoe);
    }
  }

  isShoeInFavorites(shoe)
  {
    let favoritesList = this.favoritesListService.favorites;

    for(let i = 0; i < favoritesList.length; i++)
    {
      if(shoe.id == favoritesList[i].id)
      {
        return true;
      }
    }

    return false;
  }

  shoeHasImage(shoe)
  {
    if(shoe.media.imageUrl == null || shoe.media.imageUrl == undefined || shoe.media == undefined || shoe.media == null)
    {
      return false;
    }
    else
    {
      return true;
    }
  }
}